import {Injectable} from '@angular/core';
import {Patient, PatientBasic, PatientStatistics} from "@shared/api/models/query/patient.model";
import {CrudService} from "@shared/api/services/crud.service";
import {firstValueFrom, map} from "rxjs";
import {PatientCreate, PatientUpdate} from "@shared/api/models/command/patient.model";

@Injectable({
    providedIn: 'root'
})
export class PatientsService extends CrudService<PatientBasic, Patient, PatientCreate, PatientUpdate> {

    protected override get domainEntity() {
        return 'patients'
    };

    async getStatisticsById(id: number): Promise<PatientStatistics> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id + '/statistics')
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }

    async getWeightAndIndicatorsStatistics(id: number, startDate: string, endDate: string): Promise<any> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id + '/statistics/weight-and-indicators?startDate=' + startDate + '&endDate=' + endDate)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }

    async getRomsStatistics(id: number, startDate: string, endDate: string): Promise<any> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id + '/statistics/roms?startDate=' + startDate + '&endDate=' + endDate)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }

    async getLatestDailySnapshotStatistics(id: number, startDate: string, endDate: string): Promise<any> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id + '/statistics/latest-daily-snapshot?startDate=' + startDate + '&endDate=' + endDate)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }

    async getLatestRoutineOutcomeStatistics(id: number, startDate: string, endDate: string): Promise<any> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id + '/statistics/latest-routine-outcome-monitoring?startDate=' + startDate + '&endDate=' + endDate)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }
}
